// สถานะการขอจอง
export function getColorItemBookingStatus(status) {
  let _bgColor = '#606060'
  let _color = '#ffffff'
  switch (status) {
    case 1: // ขอจอง
    case '1':
      _bgColor = '#5b9dfe' // น้ำเงิน
      break
    case 2: // ส่งกลับแก้ไข
    case '2':
      _bgColor = '#EEB189' // ส้ม
      break
    case 3: // อนุมัติจอง
    case '3':
      _bgColor = '#2da888' // เขียว
      break
    case 4: // ขอยกเลิกการจอง
    case '4':
      _bgColor = '#ffc114' // เหลือง
      break
    case 5: // ยกเลิกการจอง
    case '5':
      _bgColor = '#fb8a81' //แดง
      break

    default:
      break
  }

  const response = {
    bgColor: _bgColor,
    fontColor: _color,
  }

  return response
}

// สถานะการขอใช้
export function getColorItemRequestStatus(status) {
  let _bgColor = '#606060'
  let _color = '#ffffff'
  switch (status) {
    case 1: // ขอจอง
    case '1':
      _bgColor = '#5b9dfe' // น้ำเงิน
      break
    case 2: // ส่งกลับแก้ไข
    case '2':
      _bgColor = '#EEB189' // ส้ม
      break
    case 3: // อนุมัติจอง
    case '3':
      _bgColor = '#2da888' // เขียว
      break
    case 4: // ขอยกเลิกการจอง
    case '4':
      _bgColor = '#fb8a81' //แดง
      break

    default:
      break
  }

  const response = {
    bgColor: _bgColor,
    fontColor: _color,
  }

  return response
}
